import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams  } from 'react-router-dom';
import apiService from '../../Auth/apiService';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import SweetAlert2 from 'react-sweetalert2';
import MenuReincorporados from './MenuReincorporados';
import SeccionPageHeader from './../Utils/SeccionPageHeader';
import CargandoSpinner from './../Utils/CargandoSpinner';
import { useAuth } from './../../Auth/AuthContext';
import { FaCalendar } from 'react-icons/fa';
import { getMunicipiosCaract, saveMunicipiosCaract } from '../Utils/indexedDBUtils';

// CustomInput moved outside of Persona for best practices and prop validation
const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button
        type="button"
        className="custom-input"
        onClick={onClick}
        ref={ref}
        aria-label="Seleccionar fecha"
        style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
    >
        <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none', background: 'transparent', border: 'none' }} />
        <FaCalendar />
    </button>
));

export default function Personarei() {
    const { token, user } = useAuth();
    const hasRun = useRef(false);
    const navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const { id } = useParams();
    const { idPersona } = useParams();
    const { idCabezaFamilia } = useParams();
    const [tipoIdentificaciones, setTipoIdentificaciones] = useState([]);
    const [estadosPersonaRei, setEstadosPersonaRei] = useState([]);
    const [sexo, setSexo] = useState([]);
    const [minoria, setMinoria] = useState([]);
    const [tiposOrientacionSexual, setTiposOrientacionSexual] = useState([]);
    const [tiposIdentidadGenero, setTiposIdentidadGenero] = useState([]);
    const [tiposHabitanteCalle, setTiposHabitanteCalle] = useState([]);
    const [tiposEstrato, setTiposEstrato] = useState([]);
    const [paises, setPaises] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [pendingPaisOrigen, setPendingPaisOrigen] = useState(null);
    const [discapacidades, setDiscapacidades] = useState([]);
    const [oficios, setOficios] = useState([]);
    const [actividades, setActividades] = useState([]);
    const [tipoestudios, setTipoestudios] = useState([]);
    const [razonnoestudio, setRazonnoestudio] = useState([]);
    const [razonnosalud, setRazonnosalud] = useState([]);
    const [salud, setSalud] = useState([]);
    const [gruposisben, setGruposisben] = useState([]);
    const [ocupaciones, setOcupaciones] = useState([]);
    const [parentescos, setParentescos] = useState([]);
    const [tiposOng, setTiposOng] = useState([]);
    const [estadoscivil, setEstadoscivil] = useState([]);
    const [Cargando, setCargando] = useState(false);
    const [perFechacreacion, setPerFechacreacion] = useState();
    const [perFechamodificacion, setPerFechamodificacion] = useState();
    const [initialPayload, setInitialPayload] = useState(null);
    const [archivoDiscapacidad, setArchivoDiscapacidad] = useState(null); 
    const [navigateAfterMessage, setNavigateAfterMessage] = useState(null);
    const {register, handleSubmit, control, setValue, reset, watch, formState: { errors }} = useForm();
    const perSexo = watch('perSexo');
    const perGestante = watch('perGestante');
    const perLactante = watch('perLactante');
    const perEdad = watch('perEdad');
    const perSalud = watch('perSalud');
    
    async function getMunicipios() {
        const cachedmunicipiosCaract = await getMunicipiosCaract();
        if (cachedmunicipiosCaract) {
            setMunicipios(cachedmunicipiosCaract);
        } else {
            // If not in IndexedDB, fetch from the API
            const municipios = await fetchMunicipiosCaract();
            if (municipios) {
                setMunicipios(municipios);
                await saveMunicipiosCaract(municipios); // Save the result to IndexedDB
            }
        }
    }

    async function fetchMunicipiosCaract() {
        const url = '/parametros/municipiosActivos';
        return apiService.get(url, token)
            .then((response) => {
                if (Array.isArray(response.data)) {
                    return response.data;
                }
                return null;
            })
            .catch((error) => {
                console.error('Error fetching municipios:', error);
                return null;
            });
    }
    useEffect(() => {
        getMunicipios();
    }, []);
    useEffect(() => {
        if (pendingPaisOrigen && paises.length > 0) {
            setValue('perPaisorigen', pendingPaisOrigen);
            setPendingPaisOrigen(null);
        }
    }, [pendingPaisOrigen, paises, setValue]);
    useEffect(() => {
        if (!hasRun.current) {
            const fetchData = async () => {
                const url = '/reincorporados/crearformulariopersona';
                const obj = {id: id, idCabezaFamilia: idCabezaFamilia}
                try {
                    setCargando(true);
                    const response = await apiService.post(url, obj, token);
                    const result = await response.data;
                    setArchivoDiscapacidad(result.archivoDiscapacidad);
                    setOcupaciones(result.ocupaciones);
                    setGruposisben(result.gruposisben);
                    setEstadosPersonaRei(result.estadosReincorporados);                    
                    setPaises(result.paises);
                    setTipoIdentificaciones(result.tipoidentificacion);
                    setSexo(result.sexo);
                    setTiposOng(result.tiposOng);
                    setMinoria(result.minoria);
                    setDiscapacidades(result.discapacidades);
                    setOficios(result.oficios);
                    setActividades(result.actividades);
                    setTipoestudios(result.tipoestudios);
                    setRazonnoestudio(result.razonnoestudio);
                    setRazonnosalud(result.razonnosalud);
                    setParentescos(result.parentescos);
                    setSalud(result.salud);
                    setEstadoscivil(result.estadoscivil);
                    setTiposOrientacionSexual(result.orientacionessexuales);
                    setTiposIdentidadGenero(result.identidadesgenero);
                    setTiposHabitanteCalle(result.tiposHabitanteCalle);
                    setTiposEstrato(result.estratosSocioeconomico);
                    setInitialPayload(result);
                } catch (error) {
                    Mensaje('Error', 'Error al cargar los datos');
                    console.error('Error fetching data:', error);
                } finally {
                  setCargando(false);
                }
            };
    
            fetchData();
            hasRun.current = true;
        }
    }, [id, idPersona, token, setValue, user, reset, idCabezaFamilia, navigate]);
    
    useEffect(() => {
        if (!initialPayload) return;
        const t = setTimeout(() => {
            cargarFormulario(initialPayload);
            setInitialPayload(null);
        }, 0);
        return () => clearTimeout(t);
    }, [initialPayload]);

    function cargarFormulario(result) {
        if (result.persona) {
            result.persona.perFechanac = moment(result.persona.perFechanac, 'YYYY-MM-DD', true).isValid()
                ? moment.utc(result.persona.perFechanac).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
            result.persona.perFecharegistrosipod = moment(result.persona.perFecharegistrosipod, 'YYYY-MM-DD', true).isValid()
                ? moment.utc(result.persona.perFecharegistrosipod.substr(0, 10)).set({ hour: 12, minute: 0, second: 0 }).format('YYYY-MM-DDTHH:mm:ss')
                : moment().set({ hour: 12, minute: 0, second: 0 }).toISOString();
            setPerFechacreacion(result.persona.perFechacreacion);
            setPerFechamodificacion(result.persona.perFechamodificacion);
            result.persona.perEspartedeong = result.persona.perEspartedeong ? 'SI' : 'NO';
            result.persona.bolTienecertdiscapacidad = result.persona.bolTienecertdiscapacidad ? 'SI' : 'NO';
            reset(result.persona);
            if (result.persona.perTipoid === '14') { // Cedula de Ciudadania
                setPendingPaisOrigen('52'); // Colombia
            }
        }
        setValue('usrId', user);
        setValue('cabIdcabezafamilia', idCabezaFamilia);
        setValue('perIdpersona', idPersona);
        if (result.cabezafamilia) {
            setValue('cabNodeclaracion', result.cabezafamilia.cabNodeclaracion);
        }
        if (result.personagrupofamiliar) {
            setValue('gruIdparentesco', result.personagrupofamiliar.gruIdparentesco);
        }
        if (idPersona === idCabezaFamilia) {
            setValue('gruIdparentesco', '1');
        }
    }

    const toBase64File = (selectedFile) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result.split(',')[1]);
                return;
            }
            reject(new Error('No fue posible convertir el archivo a base64'));
        };
        reader.onerror = () => reject(new Error('Error leyendo el archivo'));
    });

    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        data.perFechanac = moment(data.perFechanac).format('YYYY-MM-DD');
        data.perFecharegistrosipod = moment(data.perFecharegistrosipod).format('YYYY-MM-DD');
        data.perEspartedeong = data.perEspartedeong === 'SI';
        data.bolTienecertdiscapacidad = data.bolTienecertdiscapacidad === 'SI';
        const file = data?.certificadoDiscapacidad?.[0];
        if(id==="0"){
            if(idCabezaFamilia === "0"){
                data.cabIdcabezafamilia = data.perIdpersona;
            }
            url = '/reincorporados/crearnuevapersona';
        }else{
            url = '/reincorporados/actualizarpersona';
        }

        try {
            if (file instanceof File) {
                data.certificadoDiscapacidad = await toBase64File(file);
                data.act_filename = file.name;
            } else {
                delete data.certificadoDiscapacidad;
                delete data.act_filename;
            }

            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                setNavigateAfterMessage(`/reincorporados/grupofamiliarrei/${data.cabIdcabezafamilia}`);
                Mensaje('Guardar persona', response.data);
            } else {
                Mensaje('Guardar persona', 'Error al guardar persona');
            }
        } catch (error) {
            if(error.status === 422){
                const respuestalista = error.response.data.errors.map(error => `<li>${error.field}-${error.message}</li>`).join('');
                Mensaje('Guardar persona fallo', `<ul>${respuestalista}</ul>`);
            } else if(error.status === 404){
                Mensaje('Guardar persona fallo', 'Persona no encontrada');
            } else if(error.status === 409){
                Mensaje('Guardar persona fallo', error.response.data);
            }else {
                Mensaje('Guardar persona fallo', `Error al guardar persona ${error}`);
            }
        } finally {
            setCargando(false);
        }
      };

    function CalcularEdad(date){
        setValue('perEdad', moment().diff(date, 'years'));
    }

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            html: text,
        });
    };
    const handleUppercase = (event) => {
        const uppercasedValue = event.target.value.toUpperCase();
        const fieldname = event.target.name;
        setValue(fieldname, uppercasedValue);
    };
    const DescargarArchivo = async (filename) => {
        if (!filename) return;
        setCargando(true);
                
        try {
            const response = await apiService.getFile('/reincorporados/descargararchivo', { nombreArchivo: filename }, token);
            if(response.status === 200){
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.download = `${filename}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            Mensaje('Descargar archivo', `Hubo un error al descargar el archivo ${filename}: ${err}`);
        } finally {
            setCargando(false);
        }
    };
    return(
        <div className="content-wrapper">
            <SeccionPageHeader 
                title="Formulario persona"
                idCabezaFamilia={idCabezaFamilia}
                url={`/reincorporados/grupofamiliarrei/${idCabezaFamilia}`}
                nombreurl="Grupo familiar"
                nombreform="persona"
                />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {(idCabezaFamilia !== "0") && 
                        <MenuReincorporados idCabezaFamilia={idCabezaFamilia}/>
                    }
                    <div className="row">
                    {/* left column */}
                    <div className="col-md-12">
                        <div className="card card-primary">
                        <div className="card-header">
                            <h3 className="card-title">Persona</h3>
                        </div>
                        {/* /.card-header */}
                        {/* form start */}
                        <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                            <input type="hidden" {...register('intIdarchivodiscp')}/>
                            <input type="hidden" {...register('act_filename')}/>
                            <div className="card-body">
                                <div className="card">
                                    <div className="card-header">
                                    <h5 className="card-title m-0">Identificaci&oacute;n - Datos Personales {idCabezaFamilia === "0"}</h5>
                                    </div>
                                    <div className="card-body">
                                    <div className="row">
                                        <div className='col-md-4'>
                                            <div className='row'>
                                                <div className="col-md-12">
                                                    Fecha de creaci&oacute;n: <b>{perFechacreacion}</b><input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                Fecha &uacute;ltimo registro: <b>{perFechamodificacion}</b>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="perIncluido">Persona en proceso de:</label>
                                                <select id="perIncluido" {...register('perIncluido')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {estadosPersonaRei.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.est_estado}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perIncluidoclassName && <p style={{color: 'red'}}>Seleccione estado</p>}
                                            </div>
                                        </div>
                                        <div hidden className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="cabNodeclaracion">Codigo reincorporados</label>
                                                <input id="cabNodeclaracion" {...register('cabNodeclaracion')} 
                                                    className="form-control" 
                                                    placeholder="Codigo reincorporados"
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                        setValue('cabNodeclaracion', value); // Update the value in the form
                                                      }}/>
                                            </div>
                                        </div>
                                        <div hidden className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="perFecharegistrosipod">Fecha registro reincorporados</label>
                                                <Controller
                                                    control={control}
                                                    name="perFecharegistrosipod"
                                                    
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => field.onChange(date)}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value ? new Date(`${field.value}`) : null}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.perFecharegistrosipod && <p style={{color: 'red'}}>Digite fecha registro victima</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="perEspartedeong">Hace parte de una organizaci&oacute;n</label>
                                                <select 
                                                    id="perEspartedeong" 
                                                    {...register('perEspartedeong')} 
                                                    onChange={(e) => {
                                                        setValue('perEspartedeong', e.target.value);
                                                        setValue('perTipoong', '');
                                                        setValue('perCualong', '');
                                                    }}
                                                    className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.perEspartedeong && <p style={{color: 'red'}}>Seleccione una opción</p>}
                                            </div>
                                        </div>
                                        {watch('perEspartedeong') === 'SI' && <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="perTipoong">¿Cuál ONG?</label>
                                                <select id="perTipoong" {...register('perTipoong')} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    {tiposOng.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tip_tipoong}
                                                    </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>}
                                        {watch('perEspartedeong') === 'SI' && <div className="col-md-4">
                                            <div className="form-group">
                                                <label htmlFor="perCualong">¿Otra ONG, Cuál?</label>
                                                <input
                                                    id="perCualong"
                                                    className="form-control"
                                                    placeholder="Nombre ONG"
                                                    {...register(
                                                        'perCualong',
                                                    )}
                                                    onChange={handleUppercase}
                                                />
                                                {errors.perCualong && <p style={{ color: 'red' }}>Digite ONG</p>}
                                            </div>
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perTipoid">Tipo identificaci&oacute;n</label>
                                                <select id="perTipoid" className='form-control' 
                                                    {...register('perTipoid', { required: true })}
                                                    onChange={(e) => {
                                                        console.log(e.target.value);
                                                        if (e.target.value === '14') { // Cedula de Ciudadania
                                                            setPendingPaisOrigen('52'); // Colombia
                                                        }
                                                    }}>
                                                    <option value="">Seleccionar</option>
                                                    {tipoIdentificaciones.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tipTipoidentificacion}-{option.tipDescripcion}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipoid && <p style={{color: 'red'}}>Seleccionar tipo identificaci&oacute;n</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perIdpersona">Identificaci&oacute;n</label>
                                                <input id="perIdpersona" className="form-control" 
                                                    {...register('perIdpersona', { required: true })}
                                                    placeholder="Identificacion"
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, ''); // Remove non-alphanumeric characters
                                                        setValue('perIdpersona', value); // Update the value in the form
                                                      }}/>
                                                {errors.perIdpersona && <p style={{color: 'red'}}>Digite el documento</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perPaisorigen">Pais origen</label>
                                                <select id="perPaisorigen" className='form-control' {...register('perPaisorigen', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {paises.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.iso} - {option.pais}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perPaisorigen && <p style={{color: 'red'}}>Seleccione pais origen</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perNombre1">Primer nombre</label>
                                                <input id="perNombre1" className="form-control" 
                                                    {...register('perNombre1', { required: true })}
                                                    onChange={handleUppercase}
                                                    placeholder="Primer Nombre"/>
                                                {errors.perNombre1 && <p style={{color: 'red'}}>Digite primer nombre</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perNombre2">Segundo nombre</label>
                                                <input id="perNombre2" className="form-control" 
                                                    {...register('perNombre2')}
                                                    onChange={handleUppercase}
                                                    placeholder="Segundo nombre"/>
                                                {errors.perNombre2 && <p style={{color: 'red'}}>Digite segundo nombre</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perApellido1">Primer apellido</label>
                                                <input id="perApellido1" className="form-control" 
                                                    {...register('perApellido1', { required: true })}
                                                    onChange={handleUppercase}
                                                    placeholder="Primer apellido"/>
                                                {errors.perApellido1 && <p style={{color: 'red'}}>Digite primer apellido</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perApellido2">Segundo apellido</label>
                                                <input id="perApellido2" className="form-control" 
                                                    {...register('perApellido2')}
                                                    onChange={handleUppercase}
                                                    placeholder="Segundo apellido"/>
                                                {errors.perApellido2 && <p style={{color: 'red'}}>Digite segundo apellido</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <div className="form-group" >
                                                <label htmlFor="gruIdparentesco">Rol familiar</label>
                                                <select id="gruIdparentesco" {...register('gruIdparentesco', { required: true })} className='form-control' >
                                                    {idPersona !== idCabezaFamilia && <option value="">Seleccionar</option>}
                                                    {parentescos.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.parParentesco}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.gruIdparentesco && <p style={{color: 'red'}}>Seleccione parentesco</p>}
                                            </div>
                                        </div>
                                        <div className='col-md-4'>
                                            <div className="form-group" >
                                                <label htmlFor="perEstadocivil">Estado civil</label>
                                                <select id="perEstadocivil" {...register('perEstadocivil')} className='form-control' >
                                                    <option value="">Seleccionar</option>
                                                    {estadoscivil.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.estEstadocivil}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perIncluidoclassName && <p style={{color: 'red'}}>Seleccione estado</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label htmlFor="perFechanac">Fecha Nacimiento</label>
                                                <Controller
                                                    control={control}
                                                    name="perFechanac"
                                                    rules={{ required: "Seleccione fecha nacimiento" }}
                                                    render={({ field }) => (
                                                        <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                            <DatePicker
                                                            placeholderText="fecha"
                                                            onChange={(date) => {field.onChange(date); CalcularEdad(date);}}
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            selected={field.value ? new Date(`${field.value}`) : null}
                                                            customInput={<CustomInput />}
                                                            locale="es"
                                                            dateFormat="yyyy-MM-dd"
                                                            maxDate={new Date()}
                                                            />
                                                        </div>
                                                    )}
                                                />
                                                {errors.perFechanac && <p style={{color: 'red'}}>Seleccione fecha nacimiento</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group" >
                                                <label htmlFor="perMunicipionacimiento">Municipio de Nacimiento</label>
                                                <select id="perMunicipionacimiento" className='form-control' {...register('perMunicipionacimiento')} >
                                                    <option value="">Seleccionar</option>
                                                    {municipios.map((option) => (
                                                        <option key={option.id} value={option.id}>
                                                            {option.munMunicipio}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.perMunicipionacimiento && <p style={{color: 'red'}}>Seleccione municipio de nacimiento</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perEdad">Edad</label>
                                                <input id="perEdad" className="form-control" 
                                                    {...register('perEdad', { required: true })}
                                                    placeholder="Edad"/>
                                                {errors.perEdad && <p style={{color: 'red'}}>Digite edad</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perSexo">Sexo</label>
                                                <select id="perSexo" className='form-control' {...register('perSexo', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {sexo.map((option) => (
                                                    <option key={option.sexNombre} value={option.sexNombre}>
                                                        {option.sexNombre}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perSexo && <p style={{color: 'red'}}>Seleccione sexo</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-2" style={{position: 'relative', alignItems: 'center'}}>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('perFallecido')}
                                                    className="custom-control-input" id="SwitchFallecido"/>
                                                <label className="custom-control-label" htmlFor="SwitchFallecido">Fallecido</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Caracter&iacute;sticas Diferenciales</h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-2" style={{position: 'relative', alignItems: 'center'}}>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('perLgtbi')}
                                                    className="custom-control-input" id="SwitchLgtbi"/>
                                                <label className="custom-control-label" htmlFor="SwitchLgtbi">LGTBI</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perOrientacionsexual">Orientacion sexual</label>
                                                <select id="perOrientacionsexual" className='form-control' {...register('perOrientacionsexual', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposOrientacionSexual.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.oriOrientacionsexual}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perOrientacionsexual && <p style={{color: 'red'}}>Seleccione orientacion sexual</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perIdentidadgenero">Identidad genero</label>
                                                <select id="perIdentidadgenero" className='form-control' {...register('perIdentidadgenero', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposIdentidadGenero.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.ideIdentidad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perIdentidadgenero && <p style={{color: 'red'}}>Seleccione identidad genero</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perHabitantecalle">Habitanza calle</label>
                                                <select id="perHabitantecalle" className='form-control' {...register('perHabitantecalle', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposHabitanteCalle.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.habTipohabitantecalle}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perHabitantecalle && <p style={{color: 'red'}}>Seleccione habitanza calle</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perCampesino">Campesino</label>
                                                <select id="perCampesino" {...register('perCampesino', { required: true })} className='form-control'>
                                                    <option value="">Seleccionar</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.perCampesino && <p style={{color: 'red'}}>Seleccione dato</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group" >
                                                <label htmlFor="perTipominoria">Etn&iacute;as</label>
                                                <select id="perTipominoria" className='form-control' {...register('perTipominoria', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {minoria.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.minMinoria}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipominoria && <p style={{color: 'red'}}>Seleccione minoria</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perEstrato">Estrato socioeconomico</label>
                                                <select id="perEstrato" className='form-control' {...register('perEstrato', { required: true })}>
                                                    <option value="">Seleccionar</option>
                                                    {tiposEstrato.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.tipEstrato}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perEstrato && <p style={{color: 'red'}}>Seleccione estrato</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="perTipodiscapacidad">¿Tipo de discapacidad diagnosticada?</label>
                                                <select id="perTipodiscapacidad" {...register('perTipodiscapacidad', { required: true })} className='form-control' >
                                                    {discapacidades.map((option) => (
                                                    <option key={option.id} value={option.id}>
                                                        {option.disDiscapacidad}
                                                    </option>
                                                    ))}
                                                </select>
                                                {errors.perTipodiscapacidad && <p style={{color: 'red'}}>Seleccione discapacidad</p>}
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="bolTienecertdiscapacidad">¿Tiene certificado de discapacidad?</label>
                                                <select 
                                                    id="bolTienecertdiscapacidad" 
                                                    {...register('bolTienecertdiscapacidad', { required: true })} 
                                                    className='form-control' 
                                                    onChange={(e) => {
                                                        setValue('bolTienecertdiscapacidad', e.target.value);
                                                        setValue('certificadoDiscapacidad', null);
                                                    }}>
                                                    <option value="">Seleccionar</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.bolTienecertdiscapacidad && <p style={{color: 'red'}}>Seleccione opción</p>}
                                            </div>
                                        </div>
                                        {watch('bolTienecertdiscapacidad') === 'SI' && <div className="col-md-3">
                                            <div className="form-group" >
                                                <label htmlFor="certificadoDiscapacidad">Certificado de discapacidad</label>
                                                <input id="certificadoDiscapacidad" type="file" className="form-control"
                                                    accept="application/pdf,.pdf"
                                                    {...register('certificadoDiscapacidad', {
                                                        validate: {
                                                            oneFile: (files) => !files || files.length <= 1,
                                                            isPdf: (files) => {
                                                                if (!files || files.length === 0) return true;
                                                                const file = files[0];
                                                                return file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
                                                            },
                                                            maxSize: (files) => {
                                                                if (!files || files.length === 0) return true;
                                                                return files[0].size <= 5 * 1024 * 1024;
                                                            },
                                                            validFileName: (files) => {
                                                                if (!files || files.length === 0) return true;
                                                                const baseName = files[0].name.replace(/\.pdf$/i, '');
                                                                return /^[A-Za-z0-9]{1,40}$/.test(baseName);
                                                            }
                                                        }
                                                    })}
                                                    />
                                                {errors.certificadoDiscapacidad?.type === 'oneFile' && <p style={{color: 'red'}}>Solo se permite un archivo</p>}
                                                {errors.certificadoDiscapacidad?.type === 'isPdf' && <p style={{color: 'red'}}>El archivo debe ser PDF</p>}
                                                {errors.certificadoDiscapacidad?.type === 'maxSize' && <p style={{color: 'red'}}>El archivo debe ser menor a 5MB</p>}
                                                {errors.certificadoDiscapacidad?.type === 'validFileName' && <p style={{color: 'red'}}>El nombre debe tener solo letras y números, máximo 40 caracteres</p>}
                                            </div>
                                        </div>}
                                        {archivoDiscapacidad && (
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor='archivoDiscapacidad'>Archivo actual:</label>
                                                    <button
                                                        id="archivoDiscapacidad" 
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        onClick={() => { DescargarArchivo(archivoDiscapacidad?.str_nombre); }}
                                                        aria-label={`Descargar ${archivoDiscapacidad?.str_nombre}`}
                                                    >
                                                        {archivoDiscapacidad?.str_nombre}
                                                    </button>
                                                </div>
                                            </div>)}
                                    </div>
                                    <div className="row">
                                    {(perSexo === 'MUJER') &&<div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group" >
                                                        <label htmlFor="perGestante">Gestante</label>
                                                        <select 
                                                            id="perGestante" 
                                                            {...register('perGestante', { validate: value => {
                                                                if (perSexo === 'MUJER' && !value) {
                                                                return 'Seleccione pregunta gestación';
                                                                }
                                                                return true;
                                                            }
                                                            })}  
                                                            className='form-control'
                                                            disabled={perSexo === 'HOMBRE'}>
                                                            <option value="">Seleccionar</option>
                                                            <option value="SI">SI</option>
                                                            <option value="NO">NO</option>
                                                        </select>
                                                        {errors.perGestante && <p style={{color: 'red'}}>Seleccione pregunta gestancia</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            {watch('perGestante') === 'SI' && <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group" >
                                                        <label htmlFor='perMesesgestacion'>Meses</label>
                                                        <select id='perMesesgestacion' {...register('perMesesgestacion', { validate: value => {
                                                                if (perGestante === 'SI' && !value) {
                                                                return 'Seleccione meses';
                                                                }
                                                                return true;
                                                            }
                                                            })} className='form-control' disabled={perSexo === 'HOMBRE'}>
                                                            <option value="">Seleccionar</option>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4">4</option>
                                                            <option value="5">5</option>
                                                            <option value="6">6</option>
                                                            <option value="7">7</option>
                                                            <option value="8">8</option>
                                                            <option value="9">9</option>
                                                        </select>
                                                        {errors.perMesesgestacion && <p style={{color: 'red'}}>Seleccione meses gestaci&oacute;n</p>}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="perFechagestancia">Fecha Gestancia</label>
                                                        <Controller
                                                            control={control}
                                                            name="perFechagestancia"
                                                            rules={{
                                                                validate: {
                                                                esMUJER: (value) => {
                                                                    if (perGestante === 'SI' && !value) {
                                                                        return 'Seleccione fecha';
                                                                    }
                                                                        return true;
                                                                    }
                                                                }
                                                            }}
                                                            render={({ field }) => (
                                                                <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                disabled={perSexo === 'HOMBRE'}
                                                                maxDate={new Date()}
                                                                />
                                                            )}
                                                        />  
                                                        {errors.perFechagestancia && <p style={{color: 'red'}}>Seleccione fecha gestaci&oacute;n</p>}
                                                        
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>}
                                        {(perSexo === 'MUJER') && <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group" >
                                                        <label htmlFor="perLactante">Lactante</label>
                                                        <select id="perLactante" {...register('perLactante', { validate: value => {
                                                                if (perSexo === 'MUJER' && !value) {
                                                                return 'Seleccione pregunta lactancia';
                                                                }
                                                                return true;
                                                            }
                                                            })} className='form-control' disabled={perSexo === 'HOMBRE'}>
                                                            <option value="">Seleccionar</option>
                                                            <option value="SI">SI</option>
                                                            <option value="NO">NO</option>
                                                        </select>
                                                        {errors.perLactante && <p style={{color: 'red'}}>Seleccione pregunta lactancia</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            {watch('perLactante') === 'SI' && <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label htmlFor="perFechalactancia">Fecha Lactancia</label>
                                                        <Controller
                                                            control={control}
                                                            name="perFechalactancia"
                                                            rules={{
                                                                validate: {
                                                                esMUJER: (value) => {
                                                                    if (perLactante === 'SI' && !value) {
                                                                        return 'Seleccione fecha';
                                                                    }
                                                                        return true;
                                                                    }
                                                                }
                                                            }}
                                                            render={({ field }) => (
                                                                <DatePicker
                                                                placeholderText="fecha"
                                                                onChange={(date) => field.onChange(date)}
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                dropdownMode="select"
                                                                selected={field.value}
                                                                customInput={<CustomInput />}
                                                                locale="es"
                                                                dateFormat="yyyy-MM-dd"
                                                                disabled={perSexo === 'HOMBRE'}
                                                                maxDate={new Date()}
                                                                />
                                                            )}
                                                        />  
                                                        {errors.perFechalactancia && <p style={{color: 'red'}}>Seleccione fecha lactancia</p>}
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>}
                                    </div>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className  ="form-group" >
                                                <label htmlFor="perMsacudiente">Menor sin Acudiente</label>
                                                <select id="perMsacudiente" {...register('perMsacudiente', { validate: value => {
                                                            if (perEdad < 18 && !value) {
                                                            return 'Seleccione pregunta menor sin acudiente';
                                                            }
                                                            return true;
                                                        }
                                                        })} className='form-control' disabled={perEdad >= 18}>
                                                    <option value="">Seleccionar</option>
                                                    <option value="SI">SI</option>
                                                    <option value="NO">NO</option>
                                                </select>
                                                {errors.perMsacudiente && <p style={{color: 'red'}}>Seleccione pregunta menor sin acudiente</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header">
                                <h5 className="card-title m-0">Educaci&oacute;n y Salud</h5>
                                </div>
                                <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className  ="form-group" >
                                            <label htmlFor="perAsisteescuela">¿Se encuentra estudiando?</label>
                                            <select id="perAsisteescuela" {...register('perAsisteescuela', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perAsisteescuela && <p style={{color: 'red'}}>Seleccione si se encuentra estudiando</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className  ="form-group" >
                                            <label htmlFor="perTipoestudioactual">Estudio Actual</label>
                                            <select {...register('perTipoestudioactual', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tipoestudios.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipDescripcion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perTipoestudioactual && <p style={{color: 'red'}}>Seleccione tipo estudio actual</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label htmlFor="perUltimogrado">&uacute;ltimo grado</label>
                                            <select id="perUltimogrado" {...register('perUltimogrado', { required: true })} className="form-control">
                                                <option value="0">No estudio</option>
                                                {Array.from({ length: 11 }, (_, i) => i + 1).map((grade) => (
                                                    <option key={grade} value={grade}>
                                                        {grade}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.perUltimogrado && <p style={{ color: 'red' }}>Seleccione el &uacute;ltimo grado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className  ="form-group" >
                                            <label htmlFor="perRazonnoestudio">Raz&oacute;n No estudia</label>
                                            <select id="perRazonnoestudio" {...register('perRazonnoestudio', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {razonnoestudio.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.razRazonnoestudio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perRazonnoestudio && <p style={{color: 'red'}}>Seleccione razon no estudio</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className  ="form-group" >
                                            <label htmlFor="intOcupacionactual">Ocupaci&oacute;n actual</label>
                                            <select 
                                                id="intOcupacionactual" 
                                                {...register('intOcupacionactual', { required: true })} 
                                                onChange={(e) => {
                                                    setValue('intOcupacionactual', e.target.value);
                                                    setValue('strOtraocupacion', ''); // Limpiar otra ocupación al cambiar la ocupación actual
                                                }}
                                                className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ocupaciones.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.strOcupacion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.intOcupacionactual && <p style={{color: 'red'}}>Seleccione ocupaci&oacute;n actual</p>}
                                        </div>
                                    </div>
                                    {watch('intOcupacionactual') === '6' && <div className="col-md-3">
                                        <div className  ="form-group" >
                                            <label htmlFor="strOtraocupacion">Otra ocupaci&oacute;n, cu&aacute;l?</label>
                                            <input 
                                                type="text" 
                                                id="strOtraocupacion" 
                                                {...register('strOtraocupacion', { validate: value => {
                                                        if (watch('intOcupacionactual') === '6' && !value) {
                                                        return 'Ingrese otra ocupaci&oacute;n';
                                                        } 
                                                        return true;
                                                    } })} 
                                                className='form-control' />
                                        </div>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perSalud">R&eacute;gimen de Salud</label>
                                            <select id="perSalud" {...register('perSalud', { required: true })} className='form-control' >
                                                 <option value="">Seleccionar</option>
                                                {salud.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.salDescripcion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perSalud && <p style={{color: 'red'}}>Seleccione salud</p>}
                                        </div>
                                    </div>
                                    {perSalud > 2 && <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perRazonnosalud">Raz&oacute;n No Salud</label>
                                            <select id="perRazonnosalud" {...register('perRazonnosalud', { validate: value => {
                                                        if (perSalud > 2 && !value) {
                                                        return 'Seleccione razon no salud';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {razonnosalud.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.razRazonnosalud}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perRazonnosalud && <p style={{color: 'red'}}>Seleccione razon no salud</p>}
                                        </div>
                                    </div>}
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="per`Sisben`">¿Se encuentra encuestado por el SISB&Eacute;N ?</label>
                                            <select 
                                                id="perSisben" 
                                                {...register('perSisben', { required: true })} 
                                                className='form-control'
                                                onChange={
                                                    (e) => {
                                                        setValue('perSisben', e.target.value);
                                                        setValue('perGruposisben', ''); // Limpiar grupo sisben al cambiar la respuesta
                                                    }
                                                } >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perSisben && <p style={{color: 'red'}}>Seleccione sisben</p>}
                                        </div>
                                    </div>
                                    {watch('perSisben') === 'SI' && <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perGruposisben">Grupo SISB&Eacute;N</label>
                                            <select 
                                                id="perGruposisben" 
                                                {...register('perGruposisben', { validate: value => {
                                                        if (perSisben === 'SI' && !value) {
                                                        return 'Seleccione grupo sisben';
                                                        }
                                                        return true;
                                                    }
                                                    })}
                                                className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {gruposisben.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.strGrupo}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.perGruposisben && <p style={{color: 'red'}}>Seleccione grupo sisben</p>}
                                        </div>
                                    </div>}          
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className  ="form-group" >
                                            <label htmlFor="perLeeescribe">Lee/Escribe</label>
                                            <select id="perLeeescribe" {...register('perLeeescribe', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.perLeeescribe && <p style={{color: 'red'}}>Seleccione pregunta lee/escribe</p>}
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>

                            </div>
                            {/* /.card-body */}
                            <div className="card-footer">
                                 <div style={{ display: 'flex', gap: '12px' }}>
                                    <button type="submit" className="btn btn-primary">Guardar</button>
                                    <button type="button" className="btn btn-primary" onClick={() => navigate(-1)}>Volver</button>
                                </div>
                            </div>
                            {/* /.card-footer */}
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    const pendingNavigate = navigateAfterMessage;
                    setSwalProps({});
                    setNavigateAfterMessage(null);
                    if (pendingNavigate) {
                        navigate(pendingNavigate);
                    }
                }}/>
        </div>
    )


}